;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
export var InternalArticleType;
(function (InternalArticleType) {
    InternalArticleType["UNKNOWN"] = "UNKNOWN";
    InternalArticleType["ARTICLE"] = "ARTICLE";
    InternalArticleType["FEATURE_REQUEST"] = "FEATURE_REQUEST";
    InternalArticleType["KNOWN_ISSUE"] = "KNOWN_ISSUE";
    InternalArticleType["VIDEO"] = "VIDEO";
})(InternalArticleType || (InternalArticleType = {}));
;
;
;
;
export var expertToolkitApiUrl = '/_serverless/expert-toolkit';
export var createExpertToolkitApi = function (http) {
    var expertToolkitApiUrl = '/_serverless/expert-toolkit';
    var api = {
        searchUserAccountsByEmail: function (dto) {
            return http.post("".concat(expertToolkitApiUrl, "/searchUserAccountsByEmail"), dto);
        },
        getUserInfo: function (dto) {
            return http.get("".concat(expertToolkitApiUrl, "/getUserInfo?userId=").concat(dto.userId, "&accountId=").concat(dto.accountId));
        },
        checkVpn: function () {
            return http.get("".concat(expertToolkitApiUrl, "/checkVpn"));
        },
        getUserEssentials: function (dto) {
            return http.get("".concat(expertToolkitApiUrl, "/getUserEssentials?accountId=").concat(dto.accountId, "&userId=").concat(dto.userId, "&ticketId=").concat(dto.ticketId));
        },
        getAccountDetails: function (dto) {
            return http.get("".concat(expertToolkitApiUrl, "/getUserAccountDetails?accountId=").concat(dto.accountId, "&userId=").concat(dto.userId));
        },
        getTicketBrief: function (dto) {
            return http.get("".concat(expertToolkitApiUrl, "/getTicketBrief?ticketId=").concat(dto.ticketId, "&accountId=").concat(dto.accountId, "&userId=").concat(dto.userId));
        },
        getUserTicketHistoryStats: function (dto) {
            return http.get("".concat(expertToolkitApiUrl, "/getUserTicketHistoryStats?ticketId=").concat(dto.ticketId));
        },
        getUserTicketHistory: function (dto) {
            return http.post("".concat(expertToolkitApiUrl, "/searchUserTicketHistory"), dto);
        },
        getTicketTechnicalData: function (dto) {
            return http.get("".concat(expertToolkitApiUrl, "/getTechnicalData?ticketId=").concat(dto.ticketId));
        },
        getUserSites: function (dto) {
            return http.get("".concat(expertToolkitApiUrl, "/getUserSitesByAccount?userId=").concat(dto.userId, "&accountId=").concat(dto.accountId, "&searchPhrase=").concat(dto.searchPhrase));
        },
        getSiteBoLinks: function (dto) {
            return http.get("".concat(expertToolkitApiUrl, "/getSiteBoLinks?userId=").concat(dto.userId, "&accountId=").concat(dto.accountId, "&metaSiteId=").concat(dto.metaSiteId));
        },
        getSiteData: function (dto) {
            return http.get("".concat(expertToolkitApiUrl, "/getUserSiteInfo?userId=").concat(dto.userId, "&accountId=").concat(dto.accountId, "&msid=").concat(dto.siteId));
        },
        queryExpertAssistant: function (dto) {
            return http.get("".concat(expertToolkitApiUrl, "/expertAssistant/query?query=").concat(dto.query, "&userId=").concat(dto.userId, "&aiVersion=").concat(dto.aiVersion));
        },
        getInternalRelatedDocs: function (dto) {
            return http.post("".concat(expertToolkitApiUrl, "/expertAssistant/getInternalRelatedDocs"), dto);
        },
    };
    return api;
};
export * from './user-account-Info.builder';
export * from './account-Info.builder';
export * from './account-details.builder';
export * from './ticket-technical-data.builder';
export * from './user-site-data-builder';
export * from './site-data.builder';
export * from './doc-metadata.builder';
export * from './query-result-source.builder';
//# sourceMappingURL=index.js.map